import ApiBase from './apibase';

class Comunes extends ApiBase {
  constructor(config, target = undefined) {
    super('personalizacion', config, target);
  }

  /**
   * Obtiene los autores y tags mas seguidos
   */
  obtenerMasSeguidos() {
    const params = '';

    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_mas_seguidos',
        params
      }
    ]);
  }
}

export default Comunes;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/ranking.js